<script setup lang="ts">
import { mergeRegister } from "@lexical/utils";
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_LOW,
  PASTE_COMMAND,
  type PasteCommandType,
  TextNode,
} from "lexical";
import { useLexicalComposer } from "lexical-vue";
import { onMounted, onUnmounted } from "vue";

const editor = useLexicalComposer();

let unregisterListeners: () => void;

onMounted(() => {
  unregisterListeners = mergeRegister(
    editor.registerCommand<PasteCommandType>(
      PASTE_COMMAND,
      (event) => {
        const clipboardData = event instanceof ClipboardEvent ? event.clipboardData : null;
        const text = clipboardData?.getData("text/plain");
        if (!text?.includes("\n")) {
          return false;
        }

        event.preventDefault();
        editor.update(() => {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) {
            selection.insertRawText(text.replace(/\n/g, " "));
          }
        });
        return true;
      },
      COMMAND_PRIORITY_LOW
    ),
    editor.registerNodeTransform(TextNode, (node) => {
      node.setTextContent(node.getTextContent().replace(/\n/g, " "));
      return node;
    })
  );
});

onUnmounted(() => {
  unregisterListeners?.();
});
</script>

<template>
  <slot />
</template>
